module.exports = __webpack_public_path__ + "img/2-11.ccfc7537.jpg";